// types/FormatterNode.ts
import type { StrategyNode } from './BaseNode';
import { v4 as uuid } from 'uuid';
import { reinstantiate } from '../utils/nodeFactory';

export type FormatterConfig = {
    typeId: string;
    props: Record<string, any>;
    child: StrategyNode | null;
};

export class FormatterNode implements StrategyNode {
    id: string;
    type: 'Formatter' = 'Formatter';
    title?: string;
    isManualRename?: boolean;
    config: FormatterConfig;

    constructor(id: string, title?: string, isManualRename?: boolean, child: StrategyNode | null = null, typeId: string = '', props: Record<string, any> = {}) {
        this.id = id;
        this.title = title;
        this.isManualRename = isManualRename;
        this.config = {
            typeId,
            props,
            child: child ? reinstantiate(child) : null,
        };
    }

    update(id: string, patch: Partial<StrategyNode>): StrategyNode {
        if (this.id === id) {
            const incoming = (patch as any)?.config ?? {};
            const currentProps = this.config?.props ?? {};
            const incomingProps = incoming?.props ?? {};

            return new FormatterNode(
                this.id, 
                patch.title ?? this.title, 
                patch.isManualRename ?? this.isManualRename,
                incoming.child ?? this.config.child ?? null,
                incoming.typeId ?? this.config.typeId ?? '',
                { ...currentProps, ...incomingProps }
            );
        }

        if (this.config.child) {
            const updatedChild = this.config.child.update(id, patch);
            if (updatedChild !== this.config.child) {
                const updated = new FormatterNode(this.id, this.title, this.isManualRename);
                updated.config = { ...this.config, child: updatedChild };
                return updated;
            }
        }

        return this;
    }

    clone(): StrategyNode {
        const copy = new FormatterNode(uuid(), this.title, this.isManualRename);
        copy.config = {
            typeId: this.config.typeId,
            props: { ...this.config.props },
            child: this.config.child?.clone() ?? null
        };
        return copy;
    }
}
